import { render, staticRenderFns } from "./ManageInvestorAccountDetailsAllTabs.vue?vue&type=template&id=4252af31"
import script from "./ManageInvestorAccountDetailsAllTabs.vue?vue&type=script&lang=js"
export * from "./ManageInvestorAccountDetailsAllTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports